<div class="loading-container" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
</div>

<section class="socio-emotional-dashboard" *ngIf="!isLoading">
    <div class="socio-emotional-dashboard__container">
        <app-school-socio-emotional-dashboard-header
            [skills]="socioEmotionalSkills"></app-school-socio-emotional-dashboard-header>
        <app-school-socio-emotional-dashboard-filters
            (filtersChanged)="onFilterChanged($event)"></app-school-socio-emotional-dashboard-filters>

        <div class="loading-container" *ngIf="isLoadingFilters">
            <mat-spinner diameter="40"></mat-spinner>
        </div>

        <div class="bento-dashboard"
            *ngIf="schoolTestResults.length > 0 && !isLoadingFilters && selectedSchoolTestResult">

            <div class="bento-dashboard__item bento-dashboard__item--full">
                <h2 class="bento-dashboard__title">Resultados generales</h2>
                <app-socio-emotional-skills-test-results-general
                    [generalSocioEmotionalSkill]="generalSocioEmotionalSkill" [lastThreeResults]="schoolTestResults">
                </app-socio-emotional-skills-test-results-general>
            </div>

            <div class="bento-dashboard__item bento-dashboard__item--full">
                <h2 class="bento-dashboard__title">Perfil General de Habilidades</h2>
                <p class="bento-dashboard__subtitle">{{selectedSchoolTestResult.semesterName}}</p>
                <app-socio-emotional-skills-test-results-radar [skills]="socioEmotionalSkills"
                    [skillScores]="selectedSchoolTestResult.skillScores">
                </app-socio-emotional-skills-test-results-radar>
            </div>

            <div class="bento-dashboard__item">
                <h2 class="bento-dashboard__title">Progreso por Habilidad</h2>
                <p class="bento-dashboard__subtitle">{{selectedSchoolTestResult.semesterName}}</p>
                <app-socio-emotional-skills-test-results-progress-table [skills]="socioEmotionalSkills"
                    [skillScores]="selectedSchoolTestResult.skillScores">
                </app-socio-emotional-skills-test-results-progress-table>
            </div>

            <div class="bento-dashboard__item">
                <h2 class="bento-dashboard__title">Habilidades más destacadas</h2>
                <p class="bento-dashboard__subtitle">{{selectedSchoolTestResult.semesterName}}</p>
                <app-socio-emotional-skills-test-results-strengths [skills]="socioEmotionalSkills"
                    [skillScores]="selectedSchoolTestResult.skillScores">
                </app-socio-emotional-skills-test-results-strengths>
            </div>

            <div class="bento-dashboard__item bento-dashboard__item--full">
                <h2 class="bento-dashboard__title">Progreso</h2>
                <p class="bento-dashboard__subtitle">{{selectedSchoolTestResult.semesterName}}</p>
                <app-socio-emotional-skills-test-results-history-chart [skills]="socioEmotionalSkills"
                    [lastThreeResults]="schoolTestResults">
                </app-socio-emotional-skills-test-results-history-chart>
            </div>

            <div class="bento-dashboard__item bento-dashboard__item--full">
                <h2 class="bento-dashboard__title">Sugerencias realizadas por los estudiantes</h2>
                <app-school-socio-emotional-dashboard-suggestions></app-school-socio-emotional-dashboard-suggestions>
            </div>

        </div>

        <div *ngIf="schoolTestResults.length === 0 && !isLoading" class="no-results">
            <h2 class="bento-dashboard__title">No hay resultados disponibles.</h2>
            <img class="no-results__image" src="assets/pre-test/test-bw.png" alt="No data found" />
        </div>

        <div *ngIf="schoolTestResults.length > 0 && !isLoading && !selectedSchoolTestResult" class="no-results">
            <h2 class="bento-dashboard__title">No hay resultados disponibles.</h2>
            <img class="no-results__image" src="assets/pre-test/test-bw.png" alt="No data found" />
        </div>


    </div>

</section>